window.RGPlayerRoster = function (root, sizeInputs) {
  const container = root.querySelector('[data-roster]');
  const rows = root.querySelector('[data-roster-rows]');
  const saved = new Map();
  function render() {
    rows.querySelectorAll('[data-roster-key]').forEach(row => {
      saved.set(row.dataset.rosterKey, {
        name: row.querySelector('[data-player-name]').value,
        number: row.querySelector('[data-player-number]').value
      });
    });
    rows.replaceChildren();
    let total = 0;
    sizeInputs.forEach(input => {
      const qty = Math.max(0, Math.min(999, Number.parseInt(input.value, 10) || 0));
      for (let i = 1; i <= qty; i++) {
        total++;
        const key = input.dataset.variant + '-' + i;
        const row = document.createElement('div');
        row.className = 'rg-player-roster__row';
        row.dataset.rosterKey = key;
        row.dataset.size = input.dataset.size;
        const label = document.createElement('span');
        label.className = 'rg-player-roster__label';
        label.textContent = 'Jersey ' + total + ' · ' + input.dataset.size;
        const name = document.createElement('input');
        name.type = 'text'; name.maxLength = 60; name.placeholder = 'Player name';
        name.dataset.playerName = '';
        name.setAttribute('aria-label', 'Player ' + total + ' name, size ' + input.dataset.size);
        name.value = saved.get(key)?.name || '';
        const number = document.createElement('input');
        number.type = 'text'; number.inputMode = 'numeric'; number.maxLength = 4;
        number.placeholder = 'Number'; number.dataset.playerNumber = '';
        number.setAttribute('aria-label', 'Player ' + total + ' number, size ' + input.dataset.size);
        number.value = saved.get(key)?.number || '';
        row.append(label, name, number);
        rows.append(row);
      }
    });
    container.hidden = total === 0;
  }
  sizeInputs.forEach(input => input.addEventListener('input', render));
  render();
  function forSize(size) {
    return [...rows.querySelectorAll('[data-roster-key]')]
      .filter(row => row.dataset.size === size)
      .map(row => ({
        name: row.querySelector('[data-player-name]').value.trim(),
        number: row.querySelector('[data-player-number]').value.trim()
      }));
  }
  function lines() {
    return [...rows.querySelectorAll('[data-roster-key]')].map((row, index) => {
      const name = row.querySelector('[data-player-name]').value.trim() || 'To confirm';
      const number = row.querySelector('[data-player-number]').value.trim() || 'To confirm';
      return (index + 1) + '. ' + name + ' — #' + number + ' (' + row.dataset.size + ')';
    });
  }
  function propertiesForSize(size) {
    const roster = forSize(size).map((player, index) =>
      (index + 1) + '. ' + (player.name || 'To confirm') + ' — #' + (player.number || 'To confirm'));
    const properties = {};
    let part = 1, chunk = '';
    roster.forEach(line => {
      if (chunk && (chunk.length + line.length + 1 > 220)) {
        properties['Player roster ' + part++] = chunk;
        chunk = '';
      }
      chunk += (chunk ? '\n' : '') + line;
    });
    if (chunk) properties['Player roster ' + part] = chunk;
    return properties;
  }
  return { render, lines, propertiesForSize };
};
